import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SquareContainer from './SquareContainer.jsx';
import { Link, useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/free-solid-svg-icons'
import { getLink } from "../../dataProvider/links.js"
import { loginUser } from "../../actions/user.js"
import { connect } from 'react-redux'
import { error as logError } from "../../logger.js";
import { Helmet } from "react-helmet";

import emailIconV2 from "../../img/v2/contact/email.png"

import "../../scss/v2/user/login.scss"

function Login(props) {

    const { t, i18n } = useTranslation();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(false);
    let navigate = useNavigate();

    useEffect(() => {
        if (props.user && props.user.connected) return navigate(getLink('account', i18n.language));
    });

    const handleSubmit = () => {
        props.dispatch(loginUser(email, password))
        .catch((err) => {
            setError(true)
            if(err.statusCode !== 403) logError(err)
        })

    }

    return (
        <SquareContainer>
            <Helmet>
                <title>{t("meta.title.login")}</title>
                <meta name="description" content={t("meta.description.login")} />
            </Helmet>
            <div className="login">
                <div className="row">
                    <div className="col-12 col-lg-6 offset-lg-3">
                        <h1 className="user-square-container-title">{t('login.title')}</h1>
                        {error ? <div className="alert alert-danger">{t(`login.error.text`)}</div> : null}
                        <div className="user-square-container-input-group">
                            <p className="user-square-container-input-group-label">{t('login.label.email')}</p>
                            <input className="user-square-container-input-group-input" placeholder={t('login.placeholder.email')} onChange={(event) => { setEmail(event.target.value) }} />
                            <div className="user-square-container-input-group-left-icon">
                                <img className="img img-fluid user-square-container-input-group-left-icon-svg" src={emailIconV2} alt={emailIconV2} />
                            </div>
                        </div>
                        <div className="user-square-container-input-group mb-0">
                            <p className="user-square-container-input-group-label">{t('login.label.password')}</p>
                            <input className="user-square-container-input-group-input" type="password" placeholder={t('login.placeholder.password')} onChange={(event) => { setPassword(event.target.value) }} />
                            <div className="user-square-container-input-group-left-icon">
                                <FontAwesomeIcon className="user-square-container-input-group-left-icon-svg" icon={faLock} />
                            </div>
                        </div>
                        <Link to={getLink("forgotPassword", i18n.language)}>
                            <p className="login-forgot-link">{t('login.forgot.link')}</p>
                        </Link>
                        <div className="text-center">
                            <button className="button orange-button" onClick={handleSubmit}>{t('login.submit')}</button>
                            <Link to={getLink("home", i18n.language)}>
                                <p className="login-signup-link">{t('login.signup.link')}</p>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </SquareContainer>
    )

}

const mapStateToProps = state => ({ user: state.user.user });

const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(Login);